exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Markdown p {\n  margin: 0;\n}\n.Markdown p + p {\n  margin-top: 4px;\n}\nspan.Markdown p {\n  display: contents;\n}\n", ""]);

